import { SelectProps } from "@cofano/cck/Select/Select";
import { QuantityUnit } from "__generated__/graphql";
import { Select } from "@cofano/cck";
import { intl } from "LocaleWrapper";

const QuantityUnitSelect = ({ value, onChange }: Omit<SelectProps<QuantityUnit, false>, "fetchOptions">) => {
	return (
		<Select
			fetchOptions={Object.values(QuantityUnit)}
			getOptionLabel={(option) => intl.formatMessage({ id: `QUANTITY_UNIT_${option}` })}
			value={value}
			onChange={onChange}
		/>
	);
};

export default QuantityUnitSelect;
